import { Injectable } from '@angular/core'

import { IQuestionCorrectnestStrategy, AnswerChoiceCorrectnessStrategy, NumericEntryCorrectnessStrategy, AnswerValueCorrectnessStrategy } from './correctness-strategies'
import { DISPLAY_TYPE_ID_MAP, QUESTION_TYPES_ID_MAPPING, Question, UserAnswer } from '../../../data/models'

@Injectable()
export class QuestionCorrectnessService {
  private _correctnessStrategyMap: {[questionTypeID: number]: IQuestionCorrectnestStrategy} = {}
  private _displayTypeCorrectnessStrategyMap: {[displayTypeId: number]: IQuestionCorrectnestStrategy} = {}

  public constructor() {
      const answerChoiceCorrectnessStrategy = new AnswerChoiceCorrectnessStrategy()
      const numericEntryCorrectnessStrategy = new NumericEntryCorrectnessStrategy()
      const answerValueCorrectnessStrategy = new AnswerValueCorrectnessStrategy()

      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.MULTI_SELECT] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.MULTIPLE_CHOICE] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.NUMERIC_ENTRY] = numericEntryCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.QUANTITATIVE_COMPARISON] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.SENTENCE_SELECT] = answerValueCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.TEXT_COMPLETION] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.ESSAY] = this._essayStrategy()
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.GRAPHICS_INTERPRETATION] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.TABLE_ANALYSIS] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.MULTI_SOURCE_REASONING] = answerChoiceCorrectnessStrategy
      this._correctnessStrategyMap[QUESTION_TYPES_ID_MAPPING.TWO_PART_ANALYSIS] = answerChoiceCorrectnessStrategy

      this._displayTypeCorrectnessStrategyMap[DISPLAY_TYPE_ID_MAP.MULTIPLE_CHOICE] = answerChoiceCorrectnessStrategy
  }

  public isCorrect(question: Question, userAnswers: UserAnswer[]): boolean {
    const strategy = this._getStrategy(question)
    return strategy.isCorrect(question, userAnswers)
  }

  private _getStrategy(question: Question): IQuestionCorrectnestStrategy {
    const strategy = this._correctnessStrategyMap[question.questionType.id] || this._getDisplayTypeCorrectnessStrategy(question)
    if (!strategy) {
      throw new Error(`No correctness strategy defined for ${question.questionType.id}`)
    }
    return strategy
  }

  private _essayStrategy() {
    return {
      isCorrect: () => true
    }
  }

  private _getDisplayTypeCorrectnessStrategy(question: Question) {
    return question.questionType.displayType ? this._displayTypeCorrectnessStrategyMap[question.questionType.displayType.id] : null
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/question-correctness/question-correctness.service.ts